import React from 'react';
import { Tracker } from './pages/Tracker';
export function App() {
  return <Tracker data-id="element-0" />;
}